export default __webpack_public_path__ + "static/media/img-placeholder.eeb91632.jpg";